if(document.getElementById('pa_taille')) {
    let sizes = {
        'list': document.getElementById('pa_taille'),
        'previousValue': document.getElementById('pa_taille').value,
        'current': null,
        'customValue': 'sur-mesure',
        'customBlock': document.querySelector('[js-size-customizer]'),
        'customCloseBtn': document.querySelector('[js-size-customizer-close]'),
    }

    if (sizes.customBlock) {

        sizes.customBlock.style.height = sizes.customBlock.offsetHeight + 'px';
        sizes.customBlock.classList.add('closed');

        sizes.customCloseBtn.addEventListener('click', function (e) {
            $("#pa_taille").val(sizes.previousValue);
            $(".tawcvs-swatches[data-attribute_name='attribute_pa_taille']").find('[data-value="' + sizes.previousValue + '"]').addClass('selected').siblings('.selected').removeClass('selected');
            $("#pa_taille").change();

            sizes.current = sizes.previousValue;
            closeCustom();
        });

        $("#pa_taille").on("change", function () {
            sizes.current = $(this).val();
            if (sizes.current === sizes.customValue) {
                openCustom();
            } else {
                sizes.previousValue = $(this).val();
                closeCustom();
            }
        });
    }

    function closeCustom() {
        sizes.customBlock.classList.add('closed');
        $(".single_add_to_cart_button").removeClass("no-ajax_add_to_cart_button");

    }

    function openCustom() {
        if (sizes.customBlock.classList.contains('closed')) {
            sizes.customBlock.classList.remove('closed');
        }
        $(".single_add_to_cart_button").addClass("no-ajax_add_to_cart_button");
    }

}
